import { requireDashboardOrigin } from "@playbrain/auth/server/dashboardOriginGuard"
import { requireDashboardAuth } from "@playbrain/auth/server/requireDashboardAuth"
import { dashboardApiErrorMessage } from "@server/dashboard-api-errors"
import { serverRouteConfig } from "@server/server-route-config"
import { createFileRoute } from "@tanstack/react-router"
import * as z from "zod"

const updateDashboardProfileLanguageInputSchema = z.object({
  dashboardLanguage: z.enum(["en", "ja"]),
})

export const Route = createFileRoute("/api/dashboard/profile/language")(
  serverRouteConfig({
    server: {
      handlers: {
        POST: async ({ request }) => {
          const originError = requireDashboardOrigin(request)
          if (originError) return originError

          try {
            const input = updateDashboardProfileLanguageInputSchema.parse(await request.json())
            const auth = await requireDashboardAuth(request, [])
            if ("response" in auth) return auth.response

            const { updateCurrentDashboardProfileLanguage } = await import(
              "@api/features/dashboard-profile/dashboardProfile"
            )
            return Response.json(
              await updateCurrentDashboardProfileLanguage({
                dashboardLanguage: input.dashboardLanguage,
                user: auth.user,
              })
            )
          } catch (error) {
            return Response.json(
              { error: dashboardApiErrorMessage(error, "Could not save language.") },
              { status: 400 }
            )
          }
        },
      },
    },
  })
)
